// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"988085d0","337":"3b068f0c","466":"f438e156","840":"f7b5ceaf"}[chunkId] + ".chunk.js";
};